{
  "_provenance": {
    "ns": "health",
    "source": "pages/HealthPage.tsx, components/medical/** and lib/medical-display.ts (#2109 R3 lane L3)"
  },
  "callout": {
    "autoOffer": "Have {{companion}} do this for me?",
    "cta": {
      "openCalendar": "Open the calendar",
      "openMedications": "Open medications",
      "reviewDraft": "Review draft"
    },
    "draft": {
      "moderate_one": "{{name}} has had moderate symptom {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "moderate_other": "{{name}} has had moderate symptoms {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "moderateUnnamed_one": "My child has had moderate symptom {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "moderateUnnamed_other": "My child has had moderate symptoms {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "severe_one": "{{name}} has had severe symptom {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "severe_other": "{{name}} has had severe symptoms {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "severeUnnamed_one": "My child has had severe symptom {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?",
      "severeUnnamed_other": "My child has had severe symptoms {{count}} times in the last two weeks ({{dates}}). I haven’t shared this with the team yet — should I be concerned, and is there anything we should be doing differently?"
    },
    "prep": {
      "today": "{{title}} is today at {{time}}. {{notes}}",
      "todayNoNotes": "{{title}} is today at {{time}}. Prep notes are saved on the appointment.",
      "tomorrow": "{{title}} is tomorrow at {{time}}. {{notes}}",
      "tomorrowNoNotes": "{{title}} is tomorrow at {{time}}. Prep notes are saved on the appointment.",
      "weekday": "{{title}} is {{weekday}} at {{time}}. {{notes}}",
      "weekdayNoNotes": "{{title}} is {{weekday}} at {{time}}. Prep notes are saved on the appointment."
    },
    "recurrence_one": "You’ve logged {{count}} notable symptom in the last two weeks that the care team hasn’t seen yet. I drafted a question — want to review and add it?",
    "recurrence_other": "You’ve logged {{count}} notable symptoms in the last two weeks that the care team hasn’t seen yet. I drafted a question — want to review and add it?",
    "refill": "{{medication}} refill window opens {{when}}."
  },
  "card": {
    "addFollowUp": "Add follow-up",
    "answer": "Answer",
    "answered": "Answered",
    "answerRecorded": "Answer recorded",
    "deleteEntry": "Delete entry",
    "deleteMedication": "Delete medication",
    "deleteQuestion": "Delete question",
    "doctorResponded": "Doctor responded",
    "editEntry": "Edit entry",
    "editMedication": "Edit medication",
    "editQuestion": "Edit question",
    "ended": "Ended {{date}}",
    "forDate": "For {{date}}",
    "helped": "Helped",
    "logReaction": "Log reaction",
    "moveToNextVisit": "Move to next visit",
    "prescribedBy": "Prescribed by {{doctor}}",
    "reactionsLogged_one": "{{count}} reaction logged",
    "reactionsLogged_other": "{{count}} reactions logged",
    "refillAvailable": "Refill available {{date}}",
    "reported": "Reported",
    "withFood": "with food"
  },
  "chrome": {
    "add": {
      "medications": "Add medication",
      "questions": "Add question",
      "symptoms": "Log symptom"
    },
    "export": "Export symptom log",
    "filter": {
      "medications": "Filter the medications",
      "questions": "Filter the questions",
      "symptoms": "Filter the symptom log"
    },
    "print": "Print summary",
    "scope": {
      "active": "Active",
      "all": "All",
      "answered": "Answered",
      "anySeverity": "Any",
      "inactive": "Inactive",
      "notable": "Notable only",
      "pending": "Pending",
      "reactions": "Med reactions"
    },
    "search": {
      "medications": "Search medications",
      "questions": "Search questions",
      "symptoms": "Search the symptom log"
    },
    "severity": "Severity",
    "show": "Show"
  },
  "csv": {
    "header": {
      "date": "Date",
      "description": "Description",
      "doctorResponse": "Doctor’s response",
      "linkedMedication": "Linked medication",
      "reportedToCareTeam": "Reported to care team",
      "severity": "Severity",
      "type": "Type",
      "whatHelped": "What helped"
    }
  },
  "date": {
    "weekdayDate": "{{weekday}} {{date}}"
  },
  "detail": {
    "doseLog": {
      "loadFailed": "Couldn’t load the dose log.",
      "loading": "Loading the dose log…",
      "noneLogged": "No doses logged in this window.",
      "noneScheduled": "No scheduled doses in this window.",
      "note": "Only what was logged — unlogged past doses show as Missed",
      "title_one": "Dose log · last {{count}} day",
      "title_other": "Dose log · last {{count}} days"
    },
    "medication": {
      "confirmBody": "This permanently removes the medication and cannot be undone. Its dose history stops being shown, and symptom entries that reference it keep their own records but lose the medication tag. If treatment just ended, \"Mark inactive\" keeps the record instead.",
      "confirmLabel": "Delete medication",
      "confirmTitle": "Delete {{name}}?",
      "dose": "Dose",
      "ended": "Ended",
      "frequency": "Frequency",
      "frequencyWithFood": "{{frequency}} · with food",
      "genericName": "Generic name",
      "kicker": "Medication",
      "kickerInactive": "Medication · inactive",
      "markInactive": "Mark inactive",
      "prescribedBy": "Prescribed by",
      "purpose": "Purpose",
      "reactions": "Reactions",
      "reactionsValue_one": "{{count}} logged in the symptom timeline",
      "reactionsValue_other": "{{count}} logged in the symptom timeline",
      "reactivate": "Reactivate",
      "refill": "Refill",
      "started": "Started",
      "timeOfDay": "Time of day"
    },
    "question": {
      "added": "Added",
      "answer": "Answer",
      "category": "Category",
      "confirmBody": "The question will be removed. You can undo right after deleting.",
      "confirmBodyAnswered": "The question and its recorded answer will be removed. You can undo right after deleting.",
      "confirmLabel": "Delete question",
      "confirmTitle": "Delete this question?",
      "forVisit": "For visit",
      "forVisitValue": "{{title}} · {{date}}",
      "kicker": "Question",
      "kickerAnswered": "Question · answered",
      "markedAnswered": "Marked answered",
      "priority": "Priority"
    },
    "recordDetails": "Record details",
    "symptom": {
      "careTeam": "Care team",
      "confirmBody": "The entry will be removed from the timeline. You can undo right after deleting.",
      "confirmLabel": "Delete entry",
      "confirmTitle": "Delete this symptom entry?",
      "doctorSaid": "Doctor said",
      "kicker": "Symptom entry",
      "medication": "Medication",
      "notReported": "Not reported yet — Edit to update once you’ve told them",
      "severity": "Severity",
      "type": "Type",
      "whatHelped": "What helped",
      "when": "When"
    }
  },
  "doseStatus": {
    "missed": "Missed",
    "pending": "Pending",
    "skipped": "Skipped",
    "taken": "Taken"
  },
  "form": {
    "injection": "Injection",
    "liquid": "Liquid",
    "other": "Other",
    "patch": "Patch",
    "pill": "Pill"
  },
  "frequency": {
    "as_needed": "As needed",
    "every_x_hours": "Every few hours",
    "once_daily": "Once daily",
    "other": "Other schedule",
    "three_times_daily": "Three times daily",
    "twice_daily": "Twice daily",
    "weekly": "Weekly"
  },
  "memorial": {
    "body": "This page tracked appointments, medications, questions for the doctor and the symptom log during treatment. It is no longer in use. Nothing has been deleted — the record stays on file with TRF.",
    "bodyNamed": "This page tracked appointments, medications, questions for the doctor and the symptom log during treatment. It is no longer in use. Nothing has been deleted — {{name}}’s record stays on file with TRF.",
    "closed": "The care record is closed."
  },
  "modal": {
    "medication": {
      "editEyebrow": "Edit medication",
      "editTitle": "Update the details",
      "field": {
        "dose": "Dose",
        "form": "Form",
        "frequency": "Frequency",
        "genericName": "Generic name (optional)",
        "medication": "Medication",
        "notes": "Notes (optional)",
        "prescribingDoctor": "Prescribing doctor",
        "purpose": "Purpose (what is it for?)",
        "refillDate": "Refill available on",
        "startDate": "Start date",
        "timeOfDay": "Time of day"
      },
      "footer": "Saved to your medication record",
      "newEyebrow": "New medication",
      "newTitle": "What did the doctor prescribe?",
      "placeholder": {
        "dose": "4 mg",
        "genericName": "Zofran",
        "medication": "Ondansetron",
        "notes": "Anything worth remembering — “pharmacy only stocks the liquid form”",
        "prescribingDoctor": "Dr. Wilson",
        "purpose": "Anti-nausea, post-chemo"
      },
      "refillReminder": "Remind me to refill",
      "submit": "Add medication",
      "withFood": "Take with food"
    },
    "question": {
      "appointmentOption": "{{title}} — {{date}}",
      "draftedEyebrow": "Drafted by {{companion}}",
      "draftedTitle": "Edit before sending",
      "editEyebrow": "Edit question",
      "editTitle": "Update the question",
      "field": {
        "appointment": "Link to an appointment (optional)",
        "category": "Category",
        "priority": "Priority",
        "question": "Question"
      },
      "footerLater": "Saved for later",
      "footerNextVisit": "Saved for the next visit",
      "newEyebrow": "New question",
      "newTitle": "What do you want to ask the doctor?",
      "noAppointment": "No appointment",
      "placeholder": "e.g. Is the fatigue on day 4 something to worry about, or is it normal?",
      "submit": "Add question"
    },
    "symptom": {
      "editEyebrow": "Edit entry",
      "editTitle": "Update the entry",
      "field": {
        "description": "What happened?",
        "doctorResponse": "Doctor’s response (optional)",
        "linkedMedication": "Linked medication (optional)",
        "severity": "Severity",
        "type": "Type",
        "whatHelped": "What helped (optional)",
        "when": "When"
      },
      "footerFlagSevere": "{{companion}} will point out severe entries so you can share them with the care team",
      "footerSaved": "Saved to the symptom timeline",
      "newEyebrow": "Log symptom",
      "newTitle": "How are they doing?",
      "placeholder": {
        "description": "Describe what you observed — when it started, what it felt like, how long it lasted.",
        "doctorResponse": "What did they say? (verbatim is fine — {{companion}} will recognize it)",
        "whatHelped": "e.g. Cold ginger ale, cool washcloth on forehead."
      },
      "reportedToCareTeam": "I’ve already shared this with the care team",
      "submit": "Log symptom"
    }
  },
  "page": {
    "answer": {
      "label": "Doctor’s answer",
      "placeholder": "What did the doctor say?",
      "save": "Save answer"
    },
    "confirmDelete": {
      "entryBody": "The entry comes off the timeline. You can undo this from the confirmation for a few seconds.",
      "entryConfirm": "Delete entry",
      "entryTitle": "Delete this entry?",
      "medicationBody": "This removes the medication, its dose log, and the link from any symptom entries that mention it. It cannot be undone — to keep the record, mark it inactive from its details instead.",
      "medicationConfirm": "Delete medication",
      "medicationTitle": "Delete {{name}}?",
      "questionBody": "The question comes off the list. You can undo this from the confirmation for a few seconds.",
      "questionConfirm": "Delete question",
      "questionTitle": "Delete this question?"
    },
    "empty": {
      "activeMedsBody": "Add a medication so {{companion}} can track refills and reactions.",
      "activeMedsTitle": "No active medications",
      "answeredQuestionsBody": "Once a doctor answers a question, the answer will live here for the record.",
      "answeredQuestionsTitle": "No answered questions yet",
      "inactiveMedsBody": "Medications you stop will appear here for the record.",
      "inactiveMedsTitle": "No inactive medications",
      "pendingQuestionsBody": "Tap + and Add question to capture something for the next visit.",
      "pendingQuestionsTitle": "No pending questions",
      "symptomsBody": "Tap + and Log symptom to capture how the day is going. {{companion}} learns from these.",
      "symptomsTitle": "No symptom entries yet"
    },
    "followUpPrefill": "Follow-up on “{{question}}”: ",
    "lane": {
      "canWait": "Can <em>wait</em>",
      "thisVisit": "For <em>this visit</em>"
    },
    "loadFailed": "Couldn’t load your health records",
    "noMatch": {
      "filters": "Nothing matches these filters",
      "filtersHint": "Clear the filter to see every entry.",
      "query": "Nothing matches “{{query}}”",
      "queryHint": "Try a different word, or clear the search."
    },
    "severeBanner": {
      "body": "A severe symptom in the last two weeks hasn’t been shared with the care team. Want me to help you draft a message?",
      "cta": "Draft message",
      "prompt": "Help me draft a message to the care team about a severe symptom I logged.",
      "title": "Severe symptom unreported"
    }
  },
  "questionCategory": {
    "medications": "Medications",
    "next_steps": "Next steps",
    "other": "Other",
    "side_effects": "Side effects",
    "test_results": "Test results",
    "treatment": "Treatment"
  },
  "questionPriority": {
    "already_asked": "Asked",
    "can_wait": "Can wait",
    "this_visit": "For this visit"
  },
  "quoted": "“{{text}}”",
  "section": {
    "medications": "Medications",
    "questions": "Questions",
    "symptoms": "Symptom log"
  },
  "severity": {
    "mild": "Mild",
    "moderate": "Moderate",
    "severe": "Severe"
  },
  "slot": {
    "bedtime": "Bedtime",
    "evening": "Evening",
    "midday": "Midday",
    "morning": "Morning"
  },
  "symptomType": {
    "improvement": "Improvement",
    "medication_reaction": "Medication reaction",
    "other": "Other",
    "symptom": "Symptom",
    "treatment_reaction": "Treatment reaction"
  },
  "toast": {
    "changesSaved": "Changes saved.",
    "export": {
      "done": "Exported",
      "doneBody": "Symptom log downloaded as a CSV you can print or share with the care team.",
      "failed": "Export failed"
    },
    "medication": {
      "added": "Medication added",
      "addedBody": "Your medication has been added.",
      "addFailed": "Couldn’t add the medication",
      "deactivated": "Marked inactive",
      "deactivatedBody": "Moved to Inactive with today as the end date. Reactivate any time from its details.",
      "deleteFailed": "Couldn’t delete the medication",
      "reactivated": "Medication reactivated",
      "reactivatedBody": "Back on the active list.",
      "removed": "Medication removed",
      "removedBody": "The record has been deleted.",
      "updated": "Medication updated",
      "updateFailed": "Couldn’t update the medication"
    },
    "pleaseTryAgain": "Please try again",
    "question": {
      "added": "Question added",
      "addedBody": "Your question has been saved.",
      "addFailed": "Couldn’t add the question",
      "answered": "Question answered",
      "answeredBody": "Marked as answered.",
      "answerFailed": "Couldn’t mark the question answered",
      "deleted": "Question deleted",
      "deletedBody": "The question has been removed.",
      "deleteFailed": "Couldn’t delete the question",
      "restored": "Question restored",
      "restoredBody": "It’s back in the list.",
      "restoreFailed": "Couldn’t restore the question",
      "updated": "Question updated",
      "updateFailed": "Couldn’t update the question"
    },
    "symptom": {
      "deleted": "Entry deleted",
      "deletedBody": "The symptom entry has been removed.",
      "deleteFailed": "Couldn’t delete the symptom entry",
      "logFailed": "Couldn’t log the symptom",
      "logged": "Symptom logged",
      "loggedBody": "Your symptom entry has been saved.",
      "restored": "Entry restored",
      "restoredBody": "It’s back on the timeline.",
      "restoreFailed": "Couldn’t restore the entry",
      "updated": "Entry updated",
      "updateFailed": "Couldn’t update the entry"
    },
    "undoAlt": "Undo delete"
  }
}
